import { render, staticRenderFns } from "./google.vue?vue&type=template&id=a154d670&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a154d670')) {
      api.createRecord('a154d670', component.options)
    } else {
      api.reload('a154d670', component.options)
    }
    module.hot.accept("./google.vue?vue&type=template&id=a154d670&", function () {
      api.rerender('a154d670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/google.vue"
export default component.exports